export default __webpack_public_path__ + "static/media/empty-cart.e57c2a5f.svg";